import { render, staticRenderFns } from "./assign-employee.vue?vue&type=template&id=053aaf91&"
import script from "./assign-employee.vue?vue&type=script&lang=ts&"
export * from "./assign-employee.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports